// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__JnaVO","btnLarge":"Button_btnLarge__i2cYM"};